import type { MagentoProduct } from '@/types/accsProduct'
// import { useApiFetch } from '@/composables/useApiFetch'
import { wrapGqlRequest } from '@/services/graphqlEndPointCommonSetting/wrapGqlRequest'

export const useAccsProductService = () => {
    const fetchBySku = async (sku: string) => {
        const productBySkuQuery = `query getProductBySku($sku: String!) {
                                products(skus: [$sku]) {
                                    id
                                    sku
                                    urlKey
                                    inputOptions {
                                    id
                                    title
                                    type
                                    }
                                }
                                }`

        const variables = { sku }

        const res = await wrapGqlRequest(productBySkuQuery, variables, 'products')
        const data = res?.[0] as MagentoProduct | undefined

        return data
    }

    return {
        fetchBySku,
    }
}
